function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 12.534c-.003-.385.14-.756.4-1.04L8.652 7 4.4 2.506a1.531 1.531 0 010-2.075 1.33 1.33 0 011.961 0l5.232 5.532a1.521 1.521 0 010 2.072l-5.227 5.534a1.33 1.33 0 01-1.961 0 1.51 1.51 0 01-.4-1.035"
});

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMTIuNTM0Yy0uMDAzLS4zODUuMTQtLjc1Ni40LTEuMDRMOC42NTIgNyA0LjQgMi41MDZjLS41NC0uNTg2LS41NC0xLjQ4OSAwLTIuMDc1QzQuNjUyLjE1NiA1LjAwOCAwIDUuMzggMGMuMzczIDAgLjczLjE1Ni45ODEuNDMxbDUuMjMyIDUuNTMyYy41NDMuNTg0LjU0MyAxLjQ4OCAwIDIuMDcybC01LjIyNyA1LjUzNGMtLjI1Mi4yNzUtLjYwOC40MzEtLjk4LjQzMS0uMzczIDAtLjczLS4xNTYtLjk4MS0uNDMxLS4yNi0uMjgyLS40MDMtLjY1Mi0uNC0xLjAzNSIvPgo8L3N2Zz4K";
export { SvgChevron as ReactComponent };